import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";
import {toast} from "react-toastify";
import {useTranslation} from "../../../hooks/useTranslation";

export default function UserUsernameNewForm({handleClose, callback, person_id}) {
    const { t } = useTranslation();
    const [error, setError] = useState(null);

    const token = useAuthStore((state) => state.token);

    const createUsername = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        setError(null);
        const result = PartnerApi.userAddUsername({
            token,
            person_id: person_id,
            username: formData.get("username"),
        });
        result.then((result) => {
            if ("error" in result && result.code >= 300) {
                setError(result.error);
                return;
            } else if ("error" in result) {
                toast.success(result.error);
            }

            handleClose();
            if (callback) {
                callback();
            }
        });
        return false;
    }

    return (
        <form onSubmit={(e) => createUsername(e)}>

            {error && (
                <p className="alert alert-danger">{error}</p>
            )}

            <div className="mb-10">
                <label
                    className="required form-label">{t("users.email")}</label>
                <input type="email"
                       name="username"
                       required={true}
                       className="form-control form-control-solid"/>
            </div>

            <button type="submit" className="btn btn-primary">{t("users.connectUser")}</button>
        </form>
    );
}